<template>
  <div class="business-page">
    <TheBanner mobileImage="/images/business/m-banner.png"
      tabletImage="/images/business/t-banner.png" desktopImage="/images/business/banner.png"
      mobileQuerie="834px" desktopQuerie="960px" imageAlt="Banner B2B" buttonText="Vamos conversar"
      @button-clicked="buttonClicked()" titleContent="Comunicação assertiva quando e onde sua empresa precisa"
      textContent="O Melembre é um serviço de comunicação entre empresas e pessoas. Utilizamos inteligência de dados para facilitar relacionamentos e potencializar resultados.">
    </TheBanner>
    <BusinessOurFeatures />
    <BusinessOurDifferences />
    <BusinessHowWeDo />
    <BusinessHowCanWeHelp />
    <BusinessWantKnowMore />
    <BusinessFullChannel />
    <BusinessOurSystem />
    <BusinessSelfService />
    <HomeAchievedResults />
    <HomeOurPartners />
    <BusinessForm />
  </div>
</template>
<script setup lang="ts">
useSeoMeta({
  title: 'Para sua empresa',
});

const router = useRouter();
const buttonClicked = () => router.replace({ hash: "#business-form" });
</script>

<style lang="scss">
.business-page {
  .banner-section {
    padding: 54px 0px 24px;
    column-gap: 0 !important;

    .banner-title {
      max-width: 466px;
    margin: 0px auto 24px;
    }
    .banner-title,
    .banner-text {
      padding: 0px 20px;
    }

    .banner-button {
      width: 205px !important;
      height: 52px !important;
    }

    .image-component img {
      width: 100% !important;
      max-width: 434.585px;
      height: unset;
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      padding: 72px 5px 73px 30px;

      .banner-content {
        .banner-title {
          width: 367px;
        }

        .banner-text {
          width: 330px;
        }
      }

      .image-component img {
        max-width: 504px !important;
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1199px) {
      padding: 87px 10px 32px 44px;

      .banner-content {
        width: 421px;

      }
    }

    @media screen and (min-width: 834px) {

      .banner-title,
      .banner-text {
        padding: 0px;
      }

      .banner-content {
        .banner-button {
          width: 199px !important;
          height: 52px !important;
        }
      }
    }

    @media screen and (min-width: 960px) {
      .banner-content {
        .banner-title {
          font-size: 48px;
          line-height: 110%;
        }

        .banner-title,
        .banner-text {
          margin-bottom: 28px;
        }
      }

      .image-component img {
        max-width: 556px !important;
        max-height: 479px !important;
      }
    }

    @media screen and (min-width: 1200px) {
      align-items: flex-end;
      justify-content: flex-start;
      padding: 66px 0px 44px;

      .banner-content {
        .banner-title {
          width: 466px;
        }

        .banner-button {
          margin-bottom: 0px;
        }
      }

      .image-component img {
        margin-left: 87px;
      }
    }
  }

  .our-partners-section .content {
    @media screen and (min-width: 1200px) {
      margin-bottom: 73px;
    }
  }
}
</style>